import clsx from "clsx";
import React from "react";
import { ScrollToController } from "../ScrollTo/ScrollToController";
import page from "./page.module.scss";

export interface PageProps extends React.ComponentProps<"div"> { }

export const Page = ({ children, className, ...props }: PageProps): React.ReactComponentElement<"div", PageProps> =>
    <div {...props} className={clsx(page.page, className)} >
        {children}
        <ScrollToController />
    </div>;
